import axios from "axios";
import heic2any from "heic2any";
import { v4 as uuidv4 } from "uuid";

export const getJpegFileFromHeic = async (file: File): Promise<File> => {
  const data = new FormData();
  data.append("img", file, file.name);

  const { convertedFile } = await convertHeic(file);
  return convertedFile;
};

export const getIndustryStockPhotos = async (
  company_type: string | number
): Promise<string[]> => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/api/get_industry_stock_photos/${company_type}`
    );
    return response?.data?.data || [];
  } catch (e) {
    console.log("Error getting industry stock photos - ", e);
    return [];
  }
};

export async function convertHeic(heicFile: File): Promise<{
  convertedBlob: Blob;
  convertedFile: File;
}> {
  const convertedBlob = (await heic2any({
    blob: heicFile,
    toType: "image/png",
  })) as Blob;
  const convertedFile = new File([convertedBlob], `${uuidv4()}.png`, {
    type: "image/png",
  });
  return { convertedBlob, convertedFile };
}
